import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { SEOHead } from "@/components/SEOHead";
import { useLanguage } from "@/lib/i18n";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

const productLinks = [
  { handle: 'pdrn-pink-sheet-masks-10-pack', labelKey: 'footer.sheetMasks' },
  { handle: 'pink-glow-serum-with-pdrn-peptides', labelKey: 'footer.serum' },
  { handle: 'smart-capsule-cream-with-collagen', labelKey: 'footer.cream' },
  { handle: 'complete-pdrn-trio-bundle', labelKey: 'footer.bundle' },
];

const NotFound = () => {
  const location = useLocation();
  const { t } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    // Prevent search engines from indexing 404 pages
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, follow';
    document.head.appendChild(meta);
    return () => { document.head.removeChild(meta); };
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        title={`${t('404.title')} | PDRN SKIN`}
        description={t('404.subtitle')}
      />
      <Header />
      
      <main className="container py-20" aria-label="Page not found">
        <div className="max-w-lg mx-auto text-center">
          <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-gradient-to-br from-secondary to-pink-200 flex items-center justify-center">
            <span className="text-3xl font-bold text-primary">404</span>
          </div>
          
          <h1 className="text-2xl md:text-3xl font-bold mb-3">{t('404.title')}</h1>
          <p className="text-muted-foreground mb-8">{t('404.subtitle')}</p>
          
          <Button asChild className="mb-12">
            <Link to="/">
              <ArrowLeft className="w-4 h-4 me-2" />
              {t('404.backHome')}
            </Link>
          </Button>

          <div>
            <h2 className="text-lg font-semibold mb-4">{t('404.popularProducts')}</h2>
            <div className="grid grid-cols-2 gap-3">
              {productLinks.map(({ handle, labelKey }) => (
                <Link
                  key={handle}
                  to={`/product/${handle}`}
                  className="p-3 bg-white/80 rounded-xl border border-white/50 text-sm font-medium hover:bg-white hover:shadow-md transition-all"
                >
                  {t(labelKey)}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default NotFound;
